/**
 * countryKey → IANA timezone suggestions (static, prefix-matched)
 * For Media Devoted | Created By Ciro Autiero
 *
 * Country keys may carry language suffixes ('BEFR' = Belgium, French lists):
 * the LONGEST map key that prefixes the normalized countryKey wins. Unknown
 * countries return null and the editor asks the operator to pick a timezone.
 */

const TZ_BY_COUNTRY: Record<string, string> = {
  AU: 'Australia/Sydney',
  FR: 'Europe/Paris',
  DE: 'Europe/Berlin',
  IT: 'Europe/Rome',
  ES: 'Europe/Madrid',
  UK: 'Europe/London',
  GB: 'Europe/London',
  US: 'America/New_York',
  CA: 'America/Toronto',
  BE: 'Europe/Brussels',
  BEFR: 'Europe/Brussels',
  BENL: 'Europe/Brussels',
  NL: 'Europe/Amsterdam',
  PT: 'Europe/Lisbon',
  PL: 'Europe/Warsaw',
  AT: 'Europe/Vienna',
  CH: 'Europe/Zurich',
  IE: 'Europe/Dublin',
  NZ: 'Pacific/Auckland',
  ZA: 'Africa/Johannesburg',
};

/** Suggested IANA timezone for a traffic country key; null = no suggestion. */
export function suggestTimezone(countryKey: string): string | null {
  const key = countryKey.trim().toUpperCase();
  if (!key) return null;
  let best: string | null = null;
  let bestLength = 0;
  for (const [prefix, tz] of Object.entries(TZ_BY_COUNTRY)) {
    if (key.startsWith(prefix) && prefix.length > bestLength) {
      best = tz;
      bestLength = prefix.length;
    }
  }
  return best;
}
